export default "__VITE_ASSET__YC4S46fh__"